<div class="bim360-account-disconnected-wrapper">

  <div class="title_close">
    <h1 class="title" mat-dialog-title>{{ 'sources.autodeskAccount.accountDisconnected' | translate }}</h1>

    <mat-icon class="close" mat-dialog-close>close</mat-icon>
  </div>

  <p class="text">
    {{ 'sources.autodeskAccount.dataCannotBeProcessed' | translate }}
    {{ 'sources.autodeskAccount.pleaseFollow' | translate }}
    <a class="link" [routerLink]="routerLinkOnEditSource">{{ 'sources.autodeskAccount.link' | translate }}</a>
    {{ 'sources.autodeskAccount.reconnectAccount' | translate }}
  </p>
</div>
